import './before-after-slider.scss';
export default (() => {
  // Get all sliders on the page
  const sliders = document.querySelectorAll('.before-after-slider .slider-container');
  sliders.forEach(container => {
    const overlay = container.querySelector('.slider-overlay');
    const handle = container.querySelector('.slider-handle');

    // Function to update the slider position
    const updateSlider = x => {
      const rect = container.getBoundingClientRect();
      let offset = x - rect.left;
      if (offset < 0) offset = 0;
      if (offset > rect.width) offset = rect.width;
      const percentage = offset / rect.width * 100;
      overlay.style.width = `${percentage}%`;
      handle.style.left = `${percentage}%`;
    };
    const onDrag = event => {
      updateSlider(event.clientX || event.touches[0].clientX);
    };

    // Handle mouse drag events
    handle.addEventListener('mousedown', () => {
      window.addEventListener('mousemove', onDrag);
      window.addEventListener('mouseup', () => {
        window.removeEventListener('mousemove', onDrag);
      });
    });

    // Handle touch drag events
    handle.addEventListener('touchstart', () => {
      window.addEventListener('touchmove', onDrag);
      window.addEventListener('touchend', () => {
        window.removeEventListener('touchmove', onDrag);
      });
    });

    // Handle click event on the container to update the slider position
    container.addEventListener('click', e => {
      updateSlider(e.clientX || e.touches[0].clientX);
    });
  });
});